import axios from "axios";
import { baseurl } from "../Basurl/Baseurl";

// Normalize base URL so it always ends with a slash
const API_BASE = baseurl.endsWith("/") ? baseurl : `${baseurl}/`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

/**
 * 1. Create / Add New Referral
 * POST /referral/create (fallback /referral/add)
 */
export const createReferral = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}referral/create`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 404) {
      // Try fallback endpoint
      const fallbackResponse = await axios.post(`${API_BASE}referral/add`, data, {
        headers: getAuthHeaders(),
      });
      return fallbackResponse.data;
    }
    throw err;
  }
};

/**
 * 2. Get All Referrals (List / Search / Pagination)
 * GET /referral/list (fallback /referral/all)
 */
export const fetchReferrals = async ({ page = 1, limit = 50, search = "", status } = {}) => {
  const params = {};
  if (page !== undefined && page !== null) params.page = page;
  if (limit !== undefined && limit !== null) params.limit = limit;
  if (search && String(search).trim() !== "") params.search = String(search).trim();
  if (status !== undefined && status !== null && status !== "" && status !== "ALL") {
    params.status = status;
  }

  try {
    const response = await axios.get(`${API_BASE}referral/list`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 404) {
      // Try fallback endpoint
      const fallbackResponse = await axios.get(`${API_BASE}referral/all`, {
        params,
        headers: getAuthHeaders(),
      });
      return fallbackResponse.data;
    }
    throw err;
  }
};

/**
 * 3. Get Single Referral Details
 * GET /referral/details/:id (id can be numeric id or referral_id like REF1001)
 */
export const fetchReferralById = async (id) => {
  const response = await axios.get(`${API_BASE}referral/details/${encodeURIComponent(id)}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

/**
 * 4. Update Referral Partner
 * PUT /referral/update/:id
 */
export const updateReferral = async (id, data) => {
  const response = await axios.put(`${API_BASE}referral/update/${encodeURIComponent(id)}`, data, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

/**
 * 5. Delete Referral Partner
 * DELETE /referral/delete/:id
 */
export const deleteReferral = async (id) => {
  const response = await axios.delete(`${API_BASE}referral/delete/${encodeURIComponent(id)}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

/**
 * 6. Referral Partner Login API
 * POST /referral/login
 */
export const loginReferral = async (credentials) => {
  const response = await axios.post(`${API_BASE}referral/login`, credentials, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

/**
 * 7. Get Patients Linked to a Referral Partner
 * GET /referral/patients?referral_id=:id (fallback /referral/my_patients)
 */
export const fetchReferralPatients = async (referralId) => {
  const params = referralId ? { referral_id: referralId } : {};
  try {
    const response = await axios.get(`${API_BASE}referral/patients`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 404) {
      // Fallback
      const fallbackResponse = await axios.get(`${API_BASE}referral/my_patients`, {
        params,
        headers: getAuthHeaders(),
      });
      return fallbackResponse.data;
    }
    throw err;
  }
};
